import { Button } from '@material-ui/core'
import { Circle } from 'components'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import ReactSVG from 'react-svg'

import Logo from '../../assets/img/logo_vertical.svg'
import { _route } from '../../routes/config'

interface INativeProps {
  loading: boolean
}

interface IProps extends INativeProps, RouteComponentProps {}

const LANDING_URL = process.env.REACT_APP_LANDING_URL
class Content extends React.PureComponent<IProps> {
  toLandingPage = () => {
    if (LANDING_URL) {
      window.location.href = LANDING_URL
    }
  }
  onLogin = () => this.props.history.push(_route.login)
  onSignUp = () => this.props.history.push('/signup/parent')
  render() {
    const { loading } = this.props
    return (
      <div className="content page-min-content design-fixes">
        {loading ? (
          <Circle />
        ) : (
          <>
            <ReactSVG
              src={Logo}
              className="logo"
              onClick={this.toLandingPage}
            />
            <div className="buttons">
              <Button className="signup" onClick={this.onSignUp}>
                Join GiantLeap
              </Button>
              <Button className="login" onClick={this.onLogin}>
                Sign in
              </Button>
            </div>
          </>
        )}
      </div>
    )
  }
}

const WithRouter = withRouter(Content)

export default (props: INativeProps) => <WithRouter {...props} />



// WEBPACK FOOTER //
// ./src/pages/Landing/content.tsx